"use strict";

define('view/dashboard.button',['underscore', 'uikit/elements/button', 'uikit/modules/loader', '../templates'], function (_, Button, Loader, Templates) {
  var DashboardButton = Button.extend({
    template: Templates.IRB['dashboard.button'],
    className: 'ui segment button dashboard-button',
    tagName: 'a',
    attributes: {
      role: 'button'
    },
    options: _.extend({}, Button.prototype.options, {
      large: false,
      ariaLabelText: '',
      subText: '',
      minHeight: 75,
      tagSize: 'div'
    }),
    initialize: function initialize() {
      this.loader = new Loader({
        inline: true,
        size: 'mini'
      });
      Button.prototype.initialize.apply(this, arguments);
    },
    updateAttributes: function updateAttributes() {
      var smallPadding = '1.2em';
      var ariaLabel = 'View submissions with status ' + (this.ariaLabelText ? this.ariaLabelText : this.subText);
      this.$el.attr('aria-label', ariaLabel);
      if (this.large) {
        this.$el.css('padding-top', '');
        this.$el.css('padding-bottom', '');
      } else {
        this.$el.css('padding-top', smallPadding);
        this.$el.css('padding-bottom', smallPadding);
      }
      Button.prototype.updateAttributes.apply(this, arguments);
    }
  });
  return DashboardButton;
});

